import Stack from 'atoms/Layout/Stack/Stack';
import { cssVar } from 'styles/helper';
import styled from 'styled-components';

export const VerticalTextListContainer = styled(Stack)`
  box-shadow: ${cssVar('shadow-lg')};
`;
